import * as React from "react";

import { SFDCAuthContext } from "./SFDCAuthProvider";

export const useSFDCAuthState = () => {
  return React.useContext(SFDCAuthContext);
};
